import lozad from 'lozad'

export default {
	init() {
		jQuery(function ($) {
			$('.slides').slick({
				fade: true,
				arrows: true,
				dots: false,
				autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				pauseOnHover: false,
				responsive: [
					{
						breakpoint: 852,
						settings: {
							arrows: false,
							dots: true,
						},
					},
				],
			})
		})

		const observer = lozad('.lozad', {
			rootMargin: '10px 0px', // syntax similar to that of CSS Margin
			threshold: 0.1, // ratio of element convergence
			enableAutoReload: true, // it will reload the new image when validating attributes changes
		})
		observer.observe()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
